module.exports = __webpack_public_path__ + "img/Feature.cc87ba73.jpg";